exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-wrapper[data-v-18005d63] {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.form-wrapper[data-v-18005d63]:first-child {\n  margin-bottom: 0.104167rem;\n}\n.form-wrapper .form-label[data-v-18005d63] {\n  min-width: 0.625rem;\n}\n.error-message[data-v-18005d63] {\n  color: #f56c6c;\n  font-size: 0.072917rem;\n}", ""]);

// exports
